export default "__VITE_ASSET__mHeVoO0U__"